import { format } from 'date-fns'
import { useCallback, useEffect, useState } from 'react'
import { REPOSITORY } from '../../../api/repository/Repository'
import usePagination from '../usePagination'
const nAsignacionesPagina = 30
const initialFilters = {
  dDesde: '',
  dHasta: '',
  sCentroCosto: '',
}

const formatDate = (date) => {
  return date ? format(date, 'dd-MM-yyyy') : null
}
const columns = [
  {
    Header: 'N° recarga futura',
    accessor: 'nAsignacion',
    type: 'clickeable',
  },
  {
    Header: 'Fecha creación',
    accessor: 'dAsignacion',
    type: 'date',
  },
  {
    Header: 'Fecha ejecución recarga',
    accessor: 'dFechaProgramacion',
    type: 'date',
  },
  {
    Header: 'Cant. colaboradores',
    accessor: 'nCantEmpleados',
  },
  {
    Header: 'Monto',
    accessor: 'nMonto',
    type: 'currency',
  },
  {
    Header: 'Requiere confirmación',
    accessor: 'RequiereConfirmacion',
    type: 'refillStatus',
  },
  {
    Header: 'Confirmadas',
    accessor: 'Confirmada',
  },
  {
    Header: 'Prepago',
    accessor: 'bPrePago',
  },
  {
    Header: 'Eliminar recarga',
    accessor: 'deleteRefill',
    type: 'deleteRefill',
  },
]

const usePendingRefills = () => {
  const [pendingRefills, setPendingRefills] = useState([])

  const { handleChangePage, page } = usePagination()
  const [filters, setFilters] = useState(initialFilters)
  const changeFilter = useCallback(({ key, newValue }) => {
    setFilters((prevState) => ({ ...prevState, [key]: newValue }))
  }, [])

  const onChangeFrom = useCallback((newValue) => {
    changeFilter({ key: 'dDesde', newValue: formatDate(newValue) })
  }, [])
  const onChangeTo = useCallback((newValue) => {
    changeFilter({ key: 'dHasta', newValue: formatDate(newValue) })
  }, [])
  const onChangeCostCenter = useCallback((newValue) => {
    changeFilter({ key: 'sCentroCosto', newValue })
  }, [])
  const applyFilters = () => {
    handleChangePage(1)
    getData(1)
  }
  const getData = useCallback(
    async (varPage) => {
      await REPOSITORY.wsEmpresa.refills
        .pendingRefills({
          sPagina: varPage || page,
          nAsignacionesPagina,
          dDesde: filters.dDesde || undefined,
          dHasta: filters.dHasta || undefined,
          sCentroCosto: filters.sCentroCosto || undefined,
        })
        .then((res) => {
          setPendingRefills(res.data.cDatosRecarga)
        })
    },
    [page, filters],
  )

  useEffect(() => {
    getData(1)

    return () => {
      setPendingRefills([])
      setFilters(initialFilters)
    }
  }, [])

  return {
    pendingRefills,
    columns,
    filters,
    handleChangePage,
    applyFilters,
    onChangeCostCenter,
    onChangeFrom,
    onChangeTo,
    getData,
  }
}
export default usePendingRefills
